class Overlay {
	create(options = { transparent: false, onDestroyCallback: () => {} }) {
		$(document.body).css({
			top: `-${window.scrollY}px`
		}).addClass('hasOverlay');
		$(document.body).append(`<div class="overlay ${options.transparent ? 'overlay--transparent' : ''}" onclick="javascript:void(0)"></div>`);
		$(document.body).on('click', '.overlay', () => {
			this.destroy({ callback: options.onDestroyCallback });
		});
	}

	destroy(options = { callback: null }) {
		$(document.body).removeClass('hasOverlay');

		$('.overlay').remove();
		let scrollTo = parseInt($(document.body).css('top'));
		$('html, body').scrollTop(-scrollTo);
		$(document.body).css({
			top: null
		});

		if(options && options.callback) {
			options.callback();
		}
	}
}

export let overlay = new Overlay();
